import { _httpGet, _httpPost } from '@/service/index'

// 获取公共资源地址
export const getVideoUrl = (data: any) => _httpGet('/api/app/getOssObject', data)

// 获取联系信息
export const getContactInfo = (data: any = {}) => _httpGet('/api/app/getContactInfo', data)

// 版本信息响应类型
export interface VersionInfoData {
  clientType: string
  createTime: string
  changelog: string[]
  description: string
  isUpgrade: boolean
  strategy: number
  version: string
  currentVersion: string
  url: string
}

export interface VersionInfoResponse {
  data: VersionInfoData
}

/** 获取版本信息 */
export const getVersionInfo = (): Promise<VersionInfoResponse> => {
  return _httpGet('/api/app/version')
}

/** 同步设备区域信息（登录后调用） */
export const syncRegion = (data: any) => _httpPost('/api/app/region/sync', data)
